import type { TCacheEntry } from '@casumo/fabric-fundamentals';
import { BaseCache } from './BaseCache';

export class InMemoryCache extends BaseCache {
    private storage: Map<string, TCacheEntry> = new Map();

    async setStorage(key: string, entry: TCacheEntry): Promise<void> {
        this.storage.set(key, entry);
    }

    async getStorage(key: string): Promise<TCacheEntry | undefined> {
        return this.storage.get(key);
    }

    async deleteStorage(key: string): Promise<void> {
        this.storage.delete(key);
    }

    async clearStorage(): Promise<void> {
        this.storage.clear();
    }

    async getAllEntries(): Promise<[string, TCacheEntry][]> {
        return Array.from(this.storage.entries());
    }
}
